import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { WIDGET_VIEW_TYPES } from '@cld/upload-widget-common';
import { selectWidgetViewType, selectIsMultipleEnabled, selectIsInlineMode, selectSingleUploadAutoClose } from 'root/selectors';
import bindRootActions, { types as rootAts } from 'root/actions';
import { getComponentConsumer } from 'root/components/UploadContainer/uploaderContext';
import { NOTIFICATION_IDS } from 'root/data/NotificationsData';
import bindActions, { types as ats } from '../../actions';
import { selectIsDoneWithSuccess } from '../../selectors';
import ExpandedQueue from '../ExpandedQueue/ExpandedQueue';
import MinimizedQueue from '../MinimizedQueue/MinimizedQueue';

export class QueueView extends Component {
  componentDidMount() {
    this.clearErrorMessage();
  }

  componentDidUpdate() {
    const { isMultiple, doneWithSuccess, rootActions, isInline, singleUploadAutoClose } = this.props;

    if (singleUploadAutoClose && !isMultiple && !isInline && doneWithSuccess) {
      rootActions[rootAts.DO_CLOSE_WIDGET]();
    }
  }

  clearErrorMessage() {
    const { rootActions } = this.props;
    rootActions[rootAts.CLEAR_NOTIFICATION]({
      id: NOTIFICATION_IDS.SELECTION_MAX_REACHED,
    });
  }

  showCompleted = () => {
    this.props.actions[ats.SEND_SHOW_COMPLETED](this.props.uploader);
  };

  render() {
    return this.props.widgetViewType === WIDGET_VIEW_TYPES.MINI ? (
      <MinimizedQueue showCompleted={this.showCompleted} />
    ) : (
      <ExpandedQueue showCompleted={this.showCompleted} />
    );
  }
}

const mapDispatch = (dispatch) => ({
  actions: bindActions(dispatch),
  rootActions: bindRootActions(dispatch),
});

export default connect(
  createStructuredSelector({
    isMultiple: selectIsMultipleEnabled,
    widgetViewType: selectWidgetViewType,
    doneWithSuccess: selectIsDoneWithSuccess,
    isInline: selectIsInlineMode,
    singleUploadAutoClose: selectSingleUploadAutoClose,
  }),
  mapDispatch
)(getComponentConsumer(QueueView));
